<template>
  <div>
    <p>{{ $t("FICHA_SAUDE.SOBRE") }}</p>
    <plano-saude :fichaSaude="fichaSaude" />
    <intolerancias :fichaSaude="fichaSaude" />
    <medicacoes :fichaSaude="fichaSaude" />
    <alergias :fichaSaude="fichaSaude" />
    <deficiencias
      :fichaSaude="fichaSaude"
      :deficienciaFisica="deficienciaFisica"
      :deficienciaVisual="deficienciaVisual"
      :deficienciaAuditiva="deficienciaAuditiva"
      :deficienciaIntelectual="deficienciaIntelectual"
      :deficienciaPsicossocial="deficienciaPsicossocial"
      :deficienciaMultipla="deficienciaMultipla"
      @alteraDeficiencia="alteraDeficiencias"
    />
    <observacoes :fichaSaude="fichaSaude" />
    <confirmacao-form @confirmar="confirmacao" />
  </div>
</template>
<script>
import breadcrumb from "@/common/utils/breadcrumb";
import PlanoSaude from "./PlanoSaude";
import Intolerancias from "./Intolerancias";
import Medicacoes from "./Medicacoes";
import Alergias from "./Alergias";
import Deficiencias from "./Deficiencias";
import Observacoes from "./Observacoes";
import ConfirmacaoForm from "./ConfirmacaoForm";
import FichaSaudeService from "@/common/services/ficha-saude/ficha-saude.service";
import mensagem from "@/common/utils/mensagem";

export default {
  components: {
    PlanoSaude,
    Intolerancias,
    Medicacoes,
    Alergias,
    Deficiencias,
    Observacoes,
    ConfirmacaoForm,
  },
  data() {
    return {
      deficienciaFisica: false,
      deficienciaVisual: false,
      deficienciaAuditiva: false,
      deficienciaIntelectual: false,
      deficienciaPsicossocial: false,
      deficienciaMultipla: false,
      fichaSaude: {
        planoDeSaude: "",
        numeroCarteirinha: "",
        diabetes: false,
        medicamentoContinuo: false,
        nomeMedicamento: "",
        motivoMedicamento: "",
        alergia: false,
        especificaoAlergia: "",
        intoleranciaLactose: false,
        intoleranciaGluten: false,
        refluxo: false,
        deficiencia: false,
        especificacaoDeficiencia: "",
        tiposDeficiencias: [],
        observacoes: "",
        contratoId: "",
      },
    };
  },
  mounted() {
    this.getFichaSaude();
    breadcrumb.definir(this.$store, [{ titulo: "Ficha de Saúde" }]);
  },
  methods: {
    alteraDeficiencias(valor, deficiencia) {
      if (!this.fichaSaude.tiposDeficiencias) {
        this.fichaSaude.tiposDeficiencias = [];
      }

      if (valor && !this.fichaSaude.tiposDeficiencias.includes(deficiencia)) {
        this.fichaSaude.tiposDeficiencias.push(deficiencia);
      }
      if (!valor && this.fichaSaude.tiposDeficiencias.includes(deficiencia)) {
        let index = this.fichaSaude.tiposDeficiencias.indexOf(deficiencia);
        if (index > -1) this.fichaSaude.tiposDeficiencias.splice(index, 1);
      }
    },
    confirmacao(checkboxValue) {
      this.$emit("confirmar", checkboxValue);
      this.$emit("ficha-saude", this.fichaSaude);
    },
    getFichaSaude() {
      FichaSaudeService.buscarDados(this.$route.params.id)
        .then((data) => {
          // Garantir que fichaSaude seja sempre um objeto válido
          if (data && data.data) {
            this.fichaSaude = {
              ...this.fichaSaude, // Manter valores padrão
              ...data.data // Sobrescrever com dados do servidor
            };
          }

          // Garantir que tiposDeficiencias seja sempre um array
          if (!this.fichaSaude.tiposDeficiencias) {
            this.fichaSaude.tiposDeficiencias = [];
          }

          // Verificar se há tipos de deficiências antes de processar
          if (this.fichaSaude.tiposDeficiencias && this.fichaSaude.tiposDeficiencias.length) {
            this.fichaSaude.tiposDeficiencias.forEach((item) => {
              if (item == "Fisica") this.deficienciaFisica = true;
              if (item == "Visual") this.deficienciaVisual = true;
              if (item == "Auditiva") this.deficienciaAuditiva = true;
              if (item == "Intelectual") this.deficienciaIntelectual = true;
              if (item == "Psicossocial") this.deficienciaPsicossocial = true;
              if (item == "Multipla") this.deficienciaMultipla = true;
            });
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
          // Em caso de erro, manter os valores padrão
        })
        .finally(() => {});
    },
  },
};
</script>
